"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SidebarItem, SidebarLabel } from "@/components/sidebar";
import { useSearchStore } from "@/app/lib/searchStore";
import { SIDEBAR_ITEMS } from "@/config/config";

export default function SidebarSearchSection() {
  const setOpen = useSearchStore((state) => state.setOpen);

  return (
    <>
      {SIDEBAR_ITEMS.map((item) => {
        if (item.label === "Suche") {
          return (
            <button
              key="search"
              onClick={() => setOpen(true)}
              className="flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/6 font-medium text-zinc-950 hover:bg-zinc-950/5 hover:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:hover:bg-white/5 dark:hover:*:data-[slot=icon]:fill-white sm:py-2 sm:text-sm/5 cursor-pointer"
            >
              <FontAwesomeIcon icon={item.icon} />
              <SidebarLabel> {item.label}</SidebarLabel>
            </button>
          );
        }

        return (
          <SidebarItem key={item.href} href={item.href}>
            <FontAwesomeIcon icon={item.icon} />
            <SidebarLabel>{item.label}</SidebarLabel>
          </SidebarItem>
        );
      })}
    </>
  );
}
